import FilesEntity from '../files/files'

export default interface UsersEntity {
	_id?: string
	position: UsersPositions
	name: string
	lastname: string
	email: string
	phone: number
	image: FilesEntity
	permissions: UsersPermissionsEntity[]
	password?: string
	_created?: string
	_modified?: string
	_deleted?: boolean
}

export enum UsersPositions {
	administration = 'administration',
	support_manager = 'support_manager',
	stock_manager = 'stock_manager',
}

export interface UsersPermissionsEntity {
	_id?: string
	module: DashboardZones
	add: boolean
	view: boolean
	edit: boolean
	remove: boolean
}

export enum DashboardZones {
	orders = 'orders',
	inventary = 'inventary',
	users = 'users',
	customers = 'customers',
	contact = 'contact',
	categories = 'categories',
	coupons = 'coupons',
	sales = 'sales',
}
